import IMedia        from '../Player/Interfaces/IMedia';
import Player        from '../Player/Player';
import getUserDevice from '../Shared/Util/getUserDevice';

import SolutionType          from './Shared/Constants/SolutionType';
import ISolution             from './Shared/Interfaces/ISolution';
import ISolutionConstructor  from './Shared/Interfaces/ISolutionConstructor';
import inferAbrFormatFromSrc from './Shared/Util/inferAbrFormatFromSrc';
import SolutionGroup         from './SolutionGroups/SolutionGroup.common';

/**
 * A factory for detecting the appropriate solution for the environment,
 * asyncronously loading its entry point (via a code split "chunk"), and returning an
 * instance of it.
 */

const solutionFactory = async (player: Player, {src}: IMedia): Promise<ISolution> => {
    const abrFormat = inferAbrFormatFromSrc(src);
    const userDevice = getUserDevice(window.navigator.userAgent);
    const currentSolutionType = player.hasLoadedSolution ? player.solution.type : SolutionType.NONE;
    const solutionType = SolutionGroup.getSolutionType(abrFormat, userDevice);

    // If a solution of the same type already exists, return a reference to the
    // existing instance

    if (solutionType === currentSolutionType) return player.solution;

    // Else create new solution

    const module = await SolutionGroup.fetchSolutionModuleOfType(solutionType);
    const Solution: ISolutionConstructor = module.default;

    return new Solution(player, solutionType);
};

export default solutionFactory;